export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/74cc88c7571ddfe8037db442e45677ad.svg";